import React, { useEffect, useState } from 'react';
import './LoginSignup.css'
import { useTranslation } from 'react-i18next';
import { Redirect } from "react-router-dom";
import * as AppUrls from "../../constants/AppUrls";
import * as Constants from "../../constants/Constants";

import * as utils from '../../global/utils';
import * as Helpers from '../../global/Helpers';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import OtpPopup from '../popups/OtpPopup/OtpPopup';
import i18next from 'i18next';
import checkMarkCorrect from "../../assets/icons/ic-check-mark-correct.png";
import checkMarkFalse from "../../assets/icons/ic-check-mark-x.png";
import { format } from 'react-string-format';

import SpinnersLoadingSIP from '../SpinnersLoadingSIP/SpinnersLoadingSIP';

toast.configure();
function ForgotUsername() {
    const { t } = useTranslation();

    const [redirect, setRedirect] = useState(null);
    const [nin, setNin] = useState("");
    const [mobile, setMobile] = useState("");

    const [visible, setVisible] = useState(false);



    let leftLocalized = "left";
    let mr2Localized = "mr-2";

    if (i18next.language === "ar") {
        leftLocalized = "right";
        mr2Localized = "ml-2";
    }

    function validate() {

        if (nin.length === 0 || nin === "" || nin === null) {
            Helpers.errorNotify(t("Trading_Number_is_required"), i18next.language)
            return false;
        }

        if (mobile.length === 0 || mobile === "" || mobile === null) {
            Helpers.errorNotify(t("mobileRequired"), i18next.language)
            return false;
        }


        return true
    }



    let hideLoader = "";
    if (visible) {
        hideLoader = "";
    } else {
        hideLoader = "hide-loader";
    }

    if (redirect !== null) {
        return <Redirect to={redirect} />;
    }

    function callForgotUsername() {
        if (!validate()) {
            return;
        }
        setVisible(true);
        let response = utils.forGotusername("IOS", "192.168.26.1", nin, mobile)
        //console.log(response);
        response.then((response) => {

            setVisible(false);
            console.log("forGotusername: ", response);

            let status = response.data["Status"]

            switch (status) {
                case Constants.LoginStatus.Success:
                    Helpers.successNotify(t("successfully"), i18next.language);
                    //    setRedirect(AppUrls.login);
                    break;
                case "-1":
                    Helpers.errorNotify(t("InvalidNINorMobileNo"), i18next.language)

                    break;
                default:
                    Helpers.errorNotify(response.data["ErrorMsg"], i18next.language)
                    break;
            }
        })
            .catch((error) => {
                setVisible(false);
                console.log("error", error);
                Helpers.errorNotify(error.message, i18next.language);
            });
    }

    const callLogOff = () => {
        // 
        // props.setIsLoaderVisible(true);
        //console.log("logging out...");
        let logOffResponse = utils.logOff();
        logOffResponse
            .then((response) => {
                // props.setIsLoaderVisible(false);
                //console.log("Logged Off", response)
                if (response.status === 200) {
                    localStorage.removeItem("user");
                    localStorage.removeItem("ExpiredDocument");
                    let UserName = localStorage.getItem("username");
                    let RememberMe = localStorage.getItem("isRememberMe");
                    let language = localStorage.getItem("language");

                    let Comapnyname = localStorage.getItem(
                        Constants.localStorageConstants.company_name
                    );
                    var prev = Helpers.getPreviousConfig();
                    if (RememberMe === "true") {
                        localStorage.clear();
                        localStorage.setItem("isRememberMe", true);
                        localStorage.setItem("username", UserName);
                        localStorage.setItem("language", language);

                        localStorage.setItem(
                            Constants.localStorageConstants.company_name,
                            Comapnyname
                        );
                    } else {
                        localStorage.clear();
                        localStorage.setItem("language", language);

                        localStorage.setItem(
                            Constants.localStorageConstants.company_name,
                            Comapnyname
                        );
                    }
                    Helpers.SetpreviosConfig(prev);
                    setRedirect(AppUrls.login);
                    //   setState({ redirect: AppUrls.login }, () => {
                    //     disconnectSignalr();
                    //   });
                }
            })
            .catch((error) => {
                //props.setIsLoaderVisible(false);
                //console.log("error", error);
            });
    };


    return (
        <div className="AuthCont">
            <form name="form">
                <div className="center">
                    <>
                        <div className="form-group">
                            <input
                                className="input-textbox"
                                type="text"
                                name="nin"
                                placeholder={t("TradingNumber")}
                                value={nin}
                                onChange={(e) => {
                                    e.preventDefault();
                                    setNin(e.target.value);
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <input
                                className="input-textbox"
                                type="mobile"
                                name="mobile"
                                placeholder={t("mobileNo")}
                                value={mobile}
                                onChange={(e) => {
                                    e.preventDefault();
                                    setMobile(e.target.value);
                                }}
                            />
                        </div>

                    </>


                </div>
                <button
                    className="auth-btns btn btn-primary customBtn"
                    style={{ width: "100%" }}
                    onClick={(e) => {
                        e.preventDefault();
                        callForgotUsername();
                    }}
                >
                    {t("request")}
                </button>
                <div>
                    <button
                        className={"link WelcomeMessageDiv"}
                        style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer"
                        }}
                        onClick={
                            (event) => {
                                event.preventDefault();
                                callLogOff();
                                // setRedirect(AppUrls.login);
                                //   localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) : setRedirect(AppUrls.login);

                            }}
                    >
                        {t("cancelForgotPassword")}
                    </button>
                </div>
            </form>
            {localStorage.getItem(Constants.localStorageConstants.company_name) !== "SIFS" ?

                <div className={"center-loader loaderCss " + hideLoader} style={{ backgroundColor: "#FFFFFFD9" }}>
                    <Loader
                        type="Bars"
                        color="#00BFFF"
                        height={100}
                        width={100}
                        visible={visible}
                    />
                </div>
                :
                <div className={" center-loader " + hideLoader} style={{ height: "100%", width: "100%" }}>
                    <SpinnersLoadingSIP />
                </div>
            }
        </div >
    );
}

export default ForgotUsername;